
import { computed, defineComponent, PropType, Ref, ref } from 'vue';
import { Colli, Variant } from '@/b2c/shared/api/server-apis';
import utilities from '@/shared/utilities.service';
import dictionaryService from '@/core/dictionary/dictionary.service';

export default defineComponent({
    name: 'ProductSpecs',
    props: {
        variant: {
            type: Object as PropType<Variant>,
            required: true,
        },
        showUnitInfo: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    setup(props) {
        const specThreshold: Ref<number> = ref(4);
        const showMore: Ref<boolean> = ref(false);
        const toggleCollectionCap = utilities.toggleCollectionCap;

        const hasCollis = computed(() => {
            return props.variant?.collis?.[0] !== undefined;
        });

        const showMoreText = computed(() => {
            return dictionaryService.get(showMore.value ? 'b2c/product/closeSpecifications' : 'b2c/product/showSpecifications');
        });

        const hasProductSpecs = computed(() => {
            return props.variant.productInformation?.listItems?.[0] !== undefined;
        });

        const hasEAN = computed(() => {
            return props.variant.productInformation?.ean !== undefined && props.variant.productInformation?.ean !== '';
        });

        const hasAnyDownloads = computed(() => {
            return props.variant?.productInformation?.assemblyGuideUrl ||
                props.variant?.productInformation?.careGuideUrl ||
                props.variant?.productInformation?.userManualUrl ||
                props.variant?.productInformation?.lightingUrl;
        });

        const shouldDisplayShowMore = computed(() => {
            return hasAnyDownloads.value ||
                    hasCollis.value ||
                    hasEAN.value ||
                    hasProductSpecs.value ||
                    (props.variant.basketSpecifications?.[0] !== undefined && props.variant.basketSpecifications?.length > specThreshold.value);
        });

        const toggleSpecifications = (): void => {
            showMore.value = !showMore.value;
        };

        const colliText = (colli: Colli): string => {
            return `${colli.unitVolume} m3, ${colli.grossWeight} kg (D ${colli.depth} cm, W ${colli.width} cm, H ${colli.height} cm)`;
        };

        return {
            specThreshold,
            showMore,
            toggleCollectionCap,
            hasCollis,
            showMoreText,
            hasProductSpecs,
            hasAnyDownloads,
            hasEAN,
            shouldDisplayShowMore,
            toggleSpecifications,
            colliText,
        };
    },
});

